import { Typography } from '@mui/material';

import React from 'react';

import styles from './GrammarCheck.module.scss';

interface HighlightProps {
	text: string;
	wordColors: { word: string; color: string }[];
}

const HighlightedText: React.FC<HighlightProps> = ({ text, wordColors }) => {
	const parts = text.split(
		new RegExp(
			`(${wordColors?.map(({ word }) => word?.toLowerCase()).join('|')})`,
			'gi',
		),
	);

	return (
		<Typography className={styles['description-detail-text']}>
			{parts.map((part) => {
				const matchingPair = wordColors?.find(
					({ word }) => word?.toLowerCase() === part?.toLowerCase(),
				);
				const color = matchingPair ? matchingPair?.color : undefined;
				const textDecoration = matchingPair ? 'underline' : undefined;

				return (
					<span
						key={part}
						style={{
							backgroundColor: color,
							textDecoration,
							textDecorationColor: color,
						}}
					>
						{part}
					</span>
				);
			})}
		</Typography>
	);
};

export default HighlightedText;
